require('./angular-touch');
module.exports = 'ngTouch';



//////////////////
// WEBPACK FOOTER
// ../node_modules/angular-touch/index.js
// module id = 216
// module chunks = 0